'use client';

import { QueryClientProvider as QueryClientProviderWrapper } from '@tanstack/react-query';
import type { ReactNode } from 'react';

import { getQueryClient } from '@/utils/get-query-client';

function QueryClientProvider({ children }: { children: ReactNode }) {
  const queryClient = getQueryClient();

  return (
    <QueryClientProviderWrapper client={queryClient}>
      {children}
    </QueryClientProviderWrapper>
  );
}

export default QueryClientProvider;
